var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"novedades"},[_c('Titulo',{attrs:{"titulo":"Reporte de novedades"}}),_c('Qlik')],1)}
var staticRenderFns = []

export { render, staticRenderFns }